/**
 * Extract required vars from goodle details
 */
class GoogleDetailsParser {
	constructor() {
		this.fieldLengthMap = {
			subpremise                  : 'short_name',
			street_number               : 'short_name',
			route                       : 'long_name',
			locality                    : 'long_name',
			sublocality_level_1 		: 'long_name',
			administrative_area_level_1 : 'short_name',
			country                     : 'long_name',
			postal_code                 : 'short_name'
		};
	}

	/**
	 * @param  {String}   placeId  [description]
	 * @param  {Function} callback [description]
	 * @return {Object}
	 */
	parse(details) {
		const result = {};
		const addressComponents = details.address_components;
		for (let i = 0; i < addressComponents.length; i++) {
			const component = addressComponents[i];
			const types = component.types;

			for (let j = 0; j < types.length; j++) {
				const type = types[j];
				const key = this.fieldLengthMap[type];
				if (key && !result[type]) {
					result[type] = component[key];
				}
			}
		}

		return result;
	}

	/**
	 * @param  {Object} addressComponent [description]
	 * @return {String}
	 */
	getTypeFromAddressComponent(addressComponent) {
		return addressComponent.types[0];
	}
}

export default GoogleDetailsParser;